import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import hifcResults from './hifc-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/mortgages/home-improvement-financing-alternatives`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('hifc') },
      driverPageName: 'mortgages_home_improvement_loan',
    };
  },
};

const HIFCResultsWrapper = (props: any): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={hifcResults}
    />
  );
};

export default HIFCResultsWrapper;
